import { Zap } from "lucide-react";
import { Link } from "react-router-dom";
import { useStore } from "@/lib/store";

export function PublicFooter() {
    const setShowCookiePrefs = useStore(state => state.setShowCookiePrefs);

    return (
        <footer className="bg-slate-950 text-slate-500 py-20 border-t border-slate-900 font-sans">
            <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-4 gap-16">
                <div className="col-span-2">
                    <div className="flex items-center gap-2 mb-8 text-white font-bold text-2xl tracking-tighter">
                        <Zap className="w-8 h-8 text-blue-500 fill-current" />
                        Adaptive Endurance
                    </div>
                    <p className="max-w-sm mb-8 leading-relaxed font-medium">
                        Digitizing the gold standard of endurance sports science. Built by athletes, for athletes who refuse to settle for generic.
                    </p>
                </div>

                <div>
                    <h4 className="text-white font-black uppercase tracking-widest text-[10px] mb-8 underline decoration-blue-500 decoration-2 underline-offset-8">Resources</h4>
                    <ul className="space-y-4 text-sm font-bold">
                        <li><Link to="/features" className="hover:text-blue-500 transition-colors">Scientific Pillars</Link></li>
                        <li><Link to="/pricing" className="hover:text-blue-500 transition-colors">Pricing Strategy</Link></li>
                        <li><Link to="/roadmap" className="hover:text-blue-500 transition-colors">Open Roadmap</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-white font-black uppercase tracking-widest text-[10px] mb-8 underline decoration-blue-500 decoration-2 underline-offset-8">Support</h4>
                    <ul className="space-y-4 text-sm font-bold">
                        <li><Link to="/about" className="hover:text-blue-500 transition-colors">About Us</Link></li>
                        {/* Blog hidden per Link Audit */}
                        {/* <li><a href="#" className="hover:text-blue-500 transition-colors">Research Blog</a></li> */}
                        <li><Link to="/about" className="hover:text-blue-500 transition-colors">Science Support</Link></li>
                        <li><Link to="/features" className="hover:text-blue-500 transition-colors">Methodology Guide</Link></li>
                    </ul>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-4 mt-20 pt-10 border-t border-slate-900/50 flex flex-col md:flex-row justify-between gap-6 text-[10px] uppercase font-black tracking-widest">
                <div className="opacity-40">
                    © 2026 Adaptive Endurance. Precision Coaching Lab.
                </div>
                <div className="flex gap-8 opacity-60">
                    <Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link>
                    <Link to="/terms" className="hover:text-white transition-colors">Terms</Link>
                    <button
                        onClick={() => setShowCookiePrefs(true)}
                        className="hover:text-white transition-colors uppercase tracking-widest text-left"
                    >
                        Cookie Policy
                    </button>
                </div>
            </div>
        </footer>
    );
}
